import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";
export var Colors = {
    AZUL_GOV: "#0048B6",
    AMARELO_GOV: "#FDB913",
    VERMELHO_GOV: "#D32F2F",
    VERDE_GOV: "#007932",
    BRANCO_GOV: "#FFFFFF",
};
export var theme = createTheme({
    palette: {
        primary: {
            main: Colors.AZUL_GOV,
        },
        secondary: {
            main: "#19857b",
        },
        error: {
            main: red.A400,
        },
    },
    typography: {
        fontFamily: [
            "Roboto",
            "Montserrat",
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                // Name of the slot
                root: {
                    background: "#FFFFFF",
                    boxShadow: "none",
                },
            },
        },
    },
});
